import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=252fc0ea&scoped=true&"
import script from "./DropdownSelect.vue?vue&type=script&lang=js&"
export * from "./DropdownSelect.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=252fc0ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252fc0ea",
  null
  
)

export default component.exports
import {QSelect,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QField})
